import { FC, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { TabPanel } from '@components';
import ProductList from './ProductList/ProductList';
import { ProductSortList } from '@pages';
import StateBasedPricing from './StateBasedPricing/StateBasedPricing';

const ProductsPage: FC = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  // simple
  return (
    <Box paddingX={1} paddingTop={1} data-testid="products-page">
      <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)} data-testid="products-page-tab">
        <Tab label="Product List" />
        <Tab label="Product Rank" />
        <Tab label="State Based Pricing" />
      </Tabs>
      <TabPanel index={0} value={selectedTab}>
        <ProductList />
      </TabPanel>
      <TabPanel index={1} value={selectedTab}>
        <ProductSortList />
      </TabPanel>
      <TabPanel index={2} value={selectedTab}>
        <StateBasedPricing />
      </TabPanel>
    </Box>
  );
};

export default ProductsPage;
